export default "__VITE_ASSET__BMQX7$65__"